import { render, staticRenderFns } from "./ListaRunt.vue?vue&type=template&id=4b0a4e02&scoped=true&"
import script from "./ListaRunt.vue?vue&type=script&lang=js&"
export * from "./ListaRunt.vue?vue&type=script&lang=js&"
import style0 from "./ListaRunt.vue?vue&type=style&index=0&id=4b0a4e02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a4e02",
  null
  
)

export default component.exports